$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
CreateOrgView = require 'app/scripts/views/organization/create-org-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class BusinessClassSelectOrgView extends View
  events:
    'click .js-select-org': 'chooseOrg'
    'click .js-disabled': 'stop'
    'click .js-create-org': 'createOrg'

  render: ->
    data = {}

    if @model.organizationList.length > 0
      data.orgs = @model.organizationList.map (org) =>
        isAdmin = org.owned()
        isPremium = org.isPremium()
        needsBCUpgrade = org.needsBCUpgrade()
        isDisabled = !needsBCUpgrade || !isAdmin
        isBC2PO = org.isBC2PO()

        orgUrl = if isAdmin && (!isPremium || needsBCUpgrade)
          "/#{org.get('name')}/billing"
        else
          "#"

        memberCount = org.get('memberships').length

        _.extend(org.toJSON(), { memberCount, isAdmin, isPremium, needsBCUpgrade, orgUrl, isDisabled, isBC2PO })

    @$el.html(
      templates.fill(
        'select_org_to_upgrade',
        data
      )
    )

    @

  chooseOrg: (e) ->
    track("Select Team to Upgrade", "Choose Team")

  stop: (e) ->
    Util.stop(e)

  createOrg: (e) ->
    createOpts = {}
    restrictToEnterpriseTeamCreation = featureFlagClient.get(
      'enterprise.prevent-enterprise-paid-members-from-creating-non-enterprise-teams',
      false,
    )

    if restrictToEnterpriseTeamCreation && Auth.me().isPaidManagedEntMember()
      createOpts = { isEnterprise: true }
    else
      createOpts = { isBusinessClass: true }

    Util.stop(e)

    PopOver.toggle
      elem: $(e.target)
      top: 20
      view: CreateOrgView
      options: {
        @model,
        @modelCache,
        createOpts,
        trackingOpts: {
          category: 'upgrade',
          method: 'by clicking create team in board upgrade team menu'
        }
      }

    track("Business Class Choose Org Page", "Create New Org")

    return
